export class BiomarkerSerializer {
  static deserialize = biomarker => (
    {
      name: biomarker.name,
      value: biomarker.value,
      description: biomarker.description,
    }
  );
}
